import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum FinancialSanctionsFormErrorStatesEnum {
    GetIndividualFailed = ErrorStateScheduleEnum.FinancialSanctionsFormStatesStartIndex,
    UpdateIndividualFailed
}
